import { graphql, useStaticQuery } from "gatsby";
import { ImageDataLike } from "gatsby-plugin-image";

export type Props = {
  allWpPost: {
    nodes: {
      uri: string;
      excerpt: string;
      title: string;
      content: string;
      id: string;
      date: string;
      categories: {
        nodes: {
          name: string;
        }[];
      };
      featuredImage: {
        node: {
          sourceUrl: string;
          altText: string;
          gatsbyImage: ImageDataLike;
        };
      };
    }[];
  };
};

export const useBlogData = (language) => {
  const allWpPost: Props = useStaticQuery(
    graphql`
      {
        sv: allWpPost(sort: {date: DESC}, filter: { id: { ne: "dummy" }, language: {code: {in: [SV, EN]}}}) {
          nodes {
            uri
            excerpt
            title
            content
            id
            date
            categories {
              nodes {
                name
              }
            }
            featuredImage {
              node {
                sourceUrl
                altText
                gatsbyImage(
                  placeholder: BLURRED
                  width: 2000
                  formats: [AUTO, WEBP]
                  layout: FULL_WIDTH
                )
              }
            }
          }
        },
        no: allWpPost(sort: {date: DESC}, filter: { id: { ne: "dummy" }, language: {code: {in: [NO, EN]}}}) {
          nodes {
            uri
            excerpt
            title
            content
            id
            date
            categories {
              nodes {
                name
              }
            }
            featuredImage {
              node {
                sourceUrl
                altText
                gatsbyImage(
                  placeholder: BLURRED
                  width: 2000
                  formats: [AUTO, WEBP]
                  layout: FULL_WIDTH
                )
              }
            }
          }
        },
        en: allWpPost(sort: {date: DESC}, filter: { id: { ne: "dummy" }, language: {code: {eq: EN}}}) {
          nodes {
            uri
            excerpt
            title
            content
            id
            date
            categories {
              nodes {
                name
              }
            }
            featuredImage {
              node {
                sourceUrl
                altText
                gatsbyImage(
                  placeholder: BLURRED
                  width: 2000
                  formats: [AUTO, WEBP]
                  layout: FULL_WIDTH
                )
              }
            }
          }
        }
      }
    `
  );
  return allWpPost[language].nodes;
};
